module.exports = __webpack_public_path__ + "Uplayplus_LP_carousel_IFR_desktop.webp";